import React, { useEffect, useState, useContext, useRef } from 'react';
import FormContext from '../../helpers/formContext';
import RenderErrors from '../elements/RenderErrors';

export default function PaymentMethods(){
    const {
        inputChange,
        form_data,
        site_options,
        errors,
        RenderErrors,
    } = useContext(FormContext);

    const paymentMethods = site_options.payment_methods

    return (
        <div className="row pay-methods">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h3 className='fs-5'>Giving Method</h3>
                <span className="rbuttons2 d-lg-flex justify-content-start flex-nowrap gap-1">
                    {paymentMethods.map((data) => {
                        let is_selected = '';
                        if(parseInt(form_data.payment_method) === data.id){
                            is_selected = ' selected';
                        }

                        const visibility = data?.visibility ?? [1,2] //Payment Type Visibility
                        if(!visibility.includes(parseInt(form_data.payment_type))){// Prevent Displaying Method
                            return
                        }

                        return (<span className="rb-list-item me-1 me-lg-2" key={data.id}>
                                    <input type="radio" name="payment_method" value={data.id} checked={is_selected} className={`payment-method-${data.id}`}  onChange={inputChange} />
                                    <span className={`rb-list-label${is_selected}`}>{data.method_name}</span>
                                </span>)
                    })}
                </span>
                <RenderErrors 
                    errors={errors} 
                    name="payment_method"
                    className="text-error fs-7"
                />
            </div>
        </div>        
    )
}